import React, { useState } from 'react';
import {
  FaGlobeAmericas, FaChartLine,
  FaCheckCircle, FaChevronDown, FaMoneyBillWave,
  FaExchangeAlt, FaBriefcase, FaFileContract
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const OffshoreProducts = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      q: "Can Indian residents legally invest in foreign markets?",
      a: "Yes. Under the RBI's Liberalised Remittance Scheme (LRS), resident Indians can freely remit up to $250,000 per financial year for permissible capital account transactions, including buying shares, mutual funds, and property abroad."
    },
    {
      q: "Why should I diversify my portfolio globally?",
      a: "Global diversification protects your portfolio from domestic market volatility and rupee depreciation. It also gives you direct access to invest in global tech giants, international megatrends, and emerging markets that aren't available on Indian exchanges."
    },
    {
      q: "What are the tax implications of investing in offshore products?",
      a: "Foreign investments are subject to capital gains tax in India. Short-term and long-term capital gains classifications depend on the asset class (e.g., foreign equities vs. international ETFs). We provide complete advisory on tax-efficient routing and DTAA benefits to avoid double taxation."
    },
    {
      q: "Do you help with the remittance and compliance process?",
      a: "Absolutely. We guide you through the entire LRS process, coordinate with partner banks for favorable forex conversion rates, and ensure all regulatory reporting and compliance requirements are met."
    }
  ];

  return (
    <main className="offshore-products-page">

      <Helmet>
        {/* Basic SEO */}
        <title>Offshore Investment Products in Hyderabad | Global Investment Solutions | Lotoswealth</title>

        <meta
          name="description"
          content="Lotoswealth offers Offshore Investment Products in Hyderabad, helping investors diversify globally through international mutual funds, global equities, offshore portfolios, foreign investments, wealth protection, and cross-border investment solutions."
        />

        <meta
          name="keywords"
          content="Offshore Investment Products Hyderabad, Offshore Investments Hyderabad, Global Investment Solutions Hyderabad, International Investments Hyderabad, Foreign Investments Hyderabad, Offshore Wealth Management Hyderabad, Global Portfolio Management Hyderabad, International Mutual Funds Hyderabad, Global Equity Investments Hyderabad, Cross Border Investments Hyderabad, International Financial Planning Hyderabad, NRI Investment Services Hyderabad, Global Wealth Management Hyderabad, Offshore Portfolio Hyderabad, International Asset Management Hyderabad, Wealth Management Hyderabad, Investment Advisor Hyderabad, Financial Advisor Hyderabad, International Investment Advisor Hyderabad, Lotoswealth"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Lotoswealth" />
        <meta name="language" content="English" />

        <link rel="canonical" href="https://www.lotoswealth.com/offshore-products" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Lotoswealth" />
        <meta property="og:url" content="https://www.lotoswealth.com/offshore-products" />
        <meta
          property="og:title"
          content="Offshore Investment Products in Hyderabad | Lotoswealth"
        />
        <meta
          property="og:description"
          content="Explore Offshore Investment Products with Lotoswealth. Access global markets, international mutual funds, offshore portfolios, and diversified investment opportunities from Hyderabad."
        />
        <meta
          property="og:image"
          content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Offshore Investment Products in Hyderabad | Lotoswealth"
        />
        <meta
          name="twitter:description"
          content="Diversify your portfolio globally with Offshore Investment Products from Lotoswealth. International investments, global funds, offshore wealth management, and cross-border investment solutions."
        />
        <meta
          name="twitter:image"
          content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
        />
      </Helmet>

      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>

        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img
            src="/images/offshore-products.jpg"
            alt="Offshore Products & Global Investments"
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
            Offshore Products & Global Investing
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Diversify Your Wealth Beyond Borders
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth's Offshore Advisory. In an increasingly interconnected world, your investment portfolio shouldn't be limited by geography. We help you unlock access to global markets, international asset classes, and foreign currencies to build a truly robust wealth strategy.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Whether you are looking to hedge against currency depreciation, fund your children's overseas education, or own a stake in global technology and healthcare leaders, our offshore investment solutions provide a seamless, compliant gateway to international wealth creation.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Navigate the complexities of cross-border investments with confidence. From LRS compliance to optimal asset allocation, we manage the intricacies so you can focus on global growth.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>

            {/* Duplicated Set for Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. WHY OFFSHORE MATTERS (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">
                Why Invest in Offshore Products?
              </h2>
              <p className="text-muted line-height-lg">
                Relying solely on a single country's economy exposes your wealth to concentrated geographic and currency risks. Offshore investing allows you to decouple your wealth from domestic market cycles.
              </p>
              <p className="text-muted line-height-lg">
                By participating in international markets, you position your portfolio to capture growth from global innovation, benefit from strong foreign currencies, and establish an international financial footprint for future generations.
              </p>
            </div>
            <div className="col-lg-6 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-5">
                <h4 className="fw-bold text-teal mb-3">The Global Advantage</h4>
                <ul className="list-unstyled text-muted mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Geographic Diversification:</strong> Mitigate single-country risk.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Currency Hedging:</strong> Protect purchasing power against Rupee depreciation.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Global Leaders:</strong> Direct access to the world’s largest tech & healthcare firms.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Goal Funding:</strong> Pre-fund overseas education or global retirement plans.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          3. OUR OFFSHORE SERVICES (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white" style={{ backgroundImage: "url('/images/lotoswealth-bg.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>

        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🌍 Our Offshore Investment Solutions</h2>
            <p className="text-white">Comprehensive access to global asset classes, tailored to your risk profile.</p>
          </div>

          <div className="row g-4">

            <div className="col-lg-4 col-md-6 animate-slide-up delay-1">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaGlobeAmericas size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Direct Global Equities</h5>
                <p className="text-muted small">Invest directly in global stock exchanges (US, UK, Europe, Asia). Build a portfolio containing the world's most innovative and established companies.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-2">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaChartLine size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">International Mutual Funds & ETFs</h5>
                <p className="text-muted small">Diversify effortlessly through expertly managed international funds and Exchange Traded Funds tracking global indices and specific sectors.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-3">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaMoneyBillWave size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Global Fixed Income</h5>
                <p className="text-muted small">Add stability to your portfolio with international bonds and offshore debt instruments that offer steady yields in foreign currencies.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-4">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaExchangeAlt size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">LRS Compliance & Remittance</h5>
                <p className="text-muted small">Seamless execution of fund transfers under the Liberalised Remittance Scheme (LRS), ensuring full regulatory compliance and favorable forex rates.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-5">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaBriefcase size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Alternative Offshore Assets</h5>
                <p className="text-muted small">Exclusive access to global private equity, offshore real estate funds, and bespoke structured products for High Net Worth Individuals.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-6">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaFileContract size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Cross-Border Tax Advisory</h5>
                <p className="text-muted small">Expert guidance on the tax implications of offshore investments, helping you navigate foreign asset reporting and avoid double taxation.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          4. OUR 5-STEP GLOBAL PROCESS (Dark Slate)
      ========================================= */}
      <section className="py-5 text-white" style={{ backgroundColor: '#0a192f' }}>
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🔄 How We Take You Global</h2>
            <p className="text-light opacity-75">A streamlined, compliant approach to international investing.</p>
          </div>

          <div className="row g-4">

            <div className="col-md-6 col-lg-4 animate-slide-up delay-1">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 1 – Global Goal Assessment</h5>
                <p className="small text-muted mb-0">We evaluate your objectives—whether it's geographic diversification, funding overseas education, or currency hedging.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 2 – Portfolio Strategy</h5>
                <p className="small text-muted mb-0">Designing a tailored offshore allocation across global equities, ETFs, and fixed income based on your risk appetite.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 3 – KYC & Onboarding</h5>
                <p className="small text-muted mb-0">Assisting with international brokerage account setup, global KYC compliance, and necessary documentation.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 animate-slide-up delay-4">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 4 – Remittance & Execution</h5>
                <p className="small text-muted mb-0">Executing fund transfers via the LRS route with favorable exchange rates and seamless trade execution in foreign markets.</p>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 animate-slide-up delay-5">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 5 – Monitoring & Reporting</h5>
                <p className="small text-muted mb-0">Providing consolidated reporting of your domestic and global assets, alongside ongoing tax-compliance advisory.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          5. WHO WE SERVE & WHY CHOOSE US (Soft Blue-Gray)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#eef2f5' }}>
        <div className="container py-4">
          <div className="row g-5">

            {/* Target Audience */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">👥 Who Needs Offshore Exposure?</h3>
              <p className="text-muted small mb-4">Global investments are highly recommended for:</p>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "High Net Worth Individuals (HNIs)", "Parents Planning Foreign Education",
                  "Tech-Savvy Global Investors", "Business Owners & Entrepreneurs",
                  "NRIs Planning to Return", "Risk-Averse Portfolio Diversifiers",
                  "Global Executives", "Long-Term Wealth Preservers"
                ].map((item, idx) => (
                  <span key={idx} className="badge bg-white text-dark border p-2 shadow-sm fs-6">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Why Choose Lotoswealth */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h3 className="fw-bold mb-3 text-dark">🏆 Why Lotoswealth for Global Investing?</h3>
                <p className="text-muted small mb-4">Investing internationally requires robust infrastructure and compliance knowledge. We offer:</p>
                <div className="row g-3">
                  {[
                    "Curated Global Opportunities", "Strict Regulatory & LRS Compliance",
                    "Seamless Forex & Remittance Support", "Consolidated Portfolio Views",
                    "Institutional-Grade Research", "Transparent Fee Structures",
                    "Dedicated Cross-Border Advisory", "Tax-Efficient Routing Strategies"
                  ].map((item, idx) => (
                    <div key={idx} className="col-md-6 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                      <span className="small text-muted fw-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          6. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
            <p className="text-muted">Common queries regarding Offshore Products & Global Investing</p>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`}
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================
          7. FINAL CTA SECTION (Deep Navy)
      ========================================= */}
      <section className="py-5 text-white text-center" style={{ backgroundColor: '#0f1e2d' }}>
        <div className="container py-4">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">Ready to Take Your Portfolio Global?</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2 mx-auto" style={{ maxWidth: '600px' }}>
            Expand your investment horizons and secure your financial future against domestic volatility. Let's discuss your global wealth strategy.
          </p>
          <button className="btn-custom-teal hover-lift px-5 py-3 fs-5 border-0 rounded text-white shadow animate-slide-up delay-3">
            Schedule an Offshore Advisory Call
          </button>
        </div>
      </section>

    </main>
  );
};

export default OffshoreProducts;